export default function getBrowserLocation() {
  return fetch(`https://api.mobius.highereducation.com/v1/locate?idToken=${window.HE.publisher.identityToken}`,
    {
      method: 'GET',
      cache: 'no-cache',
    })
    .then((res) => res.json())
    .then((location) => location.countryCode)
    .catch((err) => {
      throw new Error(err);
    });
}
